import Headroom from 'headroom.js';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) {}

jQuery(function($) {
	initSlider($);
	initFixedHeader($);
});

function initSlider($) {
	$('.slider').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 5000,

			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
		});
	});
}

function initFixedHeader($) {
	var isMobile = $(window).width() < 992;

	var shrinkHeader = isMobile ? 56 : 90; // pixels before shrinking the header
    $(window).scroll(function() {
        var scroll = getCurrentScroll();
        if( scroll >= shrinkHeader ) {
            $('.site-header').addClass('scroll');
        } else {
            $('.site-header').removeClass('scroll');
        }
    });

}

// get the current vertical scroll offset
function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}
